import "../styles/Containers.css";
import "../styles/Colors.css";
import "../styles/Loading.css";

const LoadingComp = () => {
  return (
    <div>
     <span className="loader"></span>
      </div>
  );
};
export default LoadingComp;
